var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-list-item",
    {
      attrs: {
        label: _vm.transactionData.reason,
        description: _vm.transactionData.amount,
        thirdLine: _vm.transactionData.createdAt,
        navigation: "",
      },
      on: { onClick: _vm.openChargebackDetails },
    },
    [
      _c("template", { slot: "trailing" }, [
        _c(
          "div",
          { staticClass: "flex flex-col gap-1" },
          [
            _c("jade-text", { attrs: { color: "medium" } }, [
              _vm._v(" ID: " + _vm._s(_vm.transactionData.id) + " "),
            ]),
            _c(
              "jade-tag",
              {
                attrs: {
                  size: "medium",
                  variant: _vm.transactionData.statusBadge,
                },
              },
              [_vm._v(" " + _vm._s(_vm.transactionData.statusLabel) + " ")]
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }